import React from 'react';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import './notifies.css'

export default function Notifies( props ){

    //props
    const comune = props.comune;
    const reminder = props.reminder; //counting dei reminder
    const notifiche = props.notifiche;

    //variabili d'utility
    const token = JSON.parse(localStorage.getItem('token'));

    return (
        <div className="notifiesWrapper">
            <Link 
                    to={{pathname: '/servizio/' + comune.split(" ").join("_") + "/notifiche",
                        state: {"comune": comune.split(" ").join("_"),
                                token: token.accessToken,
                                username: token.username
                            }}}
                        style={{textDecoration: 'none'}}>
                    <div className="divcountingnotifiche">
                        <FontAwesomeIcon 
                            className="imgdivnotifiche"
                            icon={faBell}
                            size="1x"
                        />
                        <div className="miniCardContainer">
                            {
                                Object.values(notifiche).map((item, i) => {
                                    return (
                                        <div className="miniCard" key={i}>
                                            <div className="miniColoredDiv" style={{background: item.priority === 'Bassa' ? '#008000' : (item.priority === 'Media' ? '#FFD700' : '#FF0000')}}></div>
                                            <div className="miniCardInfoContainer">
                                                <h5>{item.reminderTitle.length > 15 ? item.reminderTitle.slice(0, 15) + '...' : item.reminderTitle}</h5>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        <div>
                            <h4 className="countnotifiche">{reminder}</h4>
                            <h4 className="pdivs">Apri Notifiche</h4>
                        </div>
                    </div>
                </Link>
        </div>
    );
};